import React, { Fragment } from 'react';
import { SlideLayout } from './SlideLayout';
import { motion } from 'framer-motion';
export function Slide1_Category() {
  const chainLinks = [{
    text: 'Predictable\nRecruiting',
    isHighlight: true
  }, {
    text: 'Sales\nTraining',
    isHighlight: false
  }, {
    text: 'Culture and\nExecution',
    isHighlight: false
  }, {
    text: 'Leadership\nDevelopment',
    isHighlight: false
  }];
  return <SlideLayout className="text-center" data-id="element-49">
      <div className="flex flex-col items-center justify-center h-full space-y-10 sm:space-y-12" data-id="element-50">
        <div className="space-y-6 sm:space-y-8 max-w-5xl px-4" data-id="element-51">
          <h1 className="text-3xl sm:text-4xl md:text-5xl lg:text-7xl xl:text-8xl font-bold tracking-tight text-white leading-[1.1]" data-id="element-52">
            Your Growth Isn't Capped by Sales. <br data-id="element-53" />
            <span className="text-[#7FE0C3]" data-id="element-54">It's Capped by Recruiting.</span>
          </h1>
          <p className="text-xl sm:text-2xl md:text-3xl text-slate-400 font-light max-w-3xl mx-auto" data-id="element-55">
            Every missed rep costs money, momentum, and morale.
          </p>
        </div>

        {/* Chain Links Visual */}
        <div className="w-full max-w-6xl px-4 overflow-x-auto pb-4 scrollbar-hide" data-id="element-56">
          <div className="flex items-center justify-center min-w-[800px] md:min-w-0" data-id="element-57">
            {chainLinks.map((link, idx) => <Fragment key={idx} data-id="element-58">
                {/* Chain Link */}
                <motion.div initial={{
              opacity: 0,
              y: 20
            }} animate={{
              opacity: 1,
              y: 0
            }} transition={{
              delay: 0.2 + idx * 0.1
            }} className={`
                    relative flex items-center justify-center px-6 py-5 rounded-lg border-2 
                    w-48 h-24 shrink-0 transition-all duration-300
                    ${link.isHighlight ? 'bg-[#7FE0C3]/20 border-[#7FE0C3] text-[#7FE0C3] shadow-[0_0_30px_-5px_rgba(127,224,195,0.3)]' : 'bg-slate-800/50 border-slate-700 text-slate-300'}
                  `} data-id="element-59">
                  <span className="text-base sm:text-lg font-bold text-center whitespace-pre-line leading-tight" data-id="element-60">
                    {link.text}
                  </span>
                </motion.div>

                {/* Connector (except after last item) */}
                {idx < chainLinks.length - 1 && <motion.div initial={{
              scaleX: 0,
              opacity: 0
            }} animate={{
              scaleX: 1,
              opacity: 1
            }} transition={{
              delay: 0.3 + idx * 0.1
            }} className="flex items-center -mx-1 z-10" data-id="element-61">
                    <div className="w-3 h-3 rounded-full bg-slate-600 shrink-0" data-id="element-62" />
                    <div className="w-8 h-1.5 bg-slate-700" data-id="element-63" />
                    <div className="w-3 h-3 rounded-full bg-slate-600 shrink-0" data-id="element-64" />
                  </motion.div>}
              </Fragment>)}
          </div>
        </div>

        {/* Key Insight Box - Smaller and moved up */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        delay: 0.8
      }} className="bg-[#7FE0C3]/5 border border-[#7FE0C3]/20 rounded-xl p-5 sm:p-6 max-w-3xl mx-auto" data-id="element-65">
          <p className="text-base sm:text-lg md:text-xl text-slate-300 font-medium leading-relaxed" data-id="element-66">
            "Most direct sales organizations have training, culture, and
            leadership figured out.{' '}
            <span className="text-white font-bold" data-id="element-67">
              They just struggle bringing in a consistent volume of qualified
              talent.
            </span>
            "
          </p>
        </motion.div>
      </div>
    </SlideLayout>;
}